import { Pipe, PipeTransform } from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'checkEfna'
})
export class CheckEfnaPipe implements PipeTransform {

  constructor(
    private translate: TranslateService,
  ) { }

  transform(value: any, args?: any): any {
    let key = '';
    if (value) {
      key = 'efna.yes';
    } else {
      key = 'efna.no';
    }

    return key === '' ? value : this.translate.get(key);
  }

}
